import { createAction, props } from '@ngrx/store';
import { ApiError, PostcodeTicketVerifyResponse } from '../client/src';
import { VerifyChildPostcodeTicket } from '../types';

export const VERIFY_POSTCODE_CHILD_TICKET_TYPE =
  '[Checkout] Verify Postcode Child Ticket';
export const verifyPostcodeChildTicket = createAction(
  VERIFY_POSTCODE_CHILD_TICKET_TYPE,
  props<{ verify: VerifyChildPostcodeTicket }>()
);

export const verifyPostcodeChildTickets = createAction(
  '[Checkout] Verify Postcode Child Tickets',
  props<{ verifyList: VerifyChildPostcodeTicket[] }>()
);

export const clearAllPostcodeChildVerifications = createAction(
  '[Checkout] Clear All Postcode Child Verifications'
);

export const checkoutAPI_verifyPostcodeChildTicketSuccess = createAction(
  `${VERIFY_POSTCODE_CHILD_TICKET_TYPE} Success`,
  props<{
    response: PostcodeTicketVerifyResponse;
    verify: VerifyChildPostcodeTicket;
  }>()
);

export const checkoutAPI_verifyPostcodeChildTicketFailure = createAction(
  `${VERIFY_POSTCODE_CHILD_TICKET_TYPE} Failure`,
  props<{ verify: VerifyChildPostcodeTicket; error?: string | ApiError }>()
);
